import { setNestedObjectValues } from "formik";
import { Link } from "gatsby";
import produce from "immer";
import React, { useState } from "react";
import styled from "styled-components";
import { SUBS_ENABLED } from "../utils/settings";
import Checkbox from "./Checkbox";
import ProductSubscriptionRadio from "./ProductSubscriptionRadio";
import { Colors } from "./styles/Colors";
import { Header4, Header5, Body, ProximaNova } from "./typography";

const Wrapper = styled.div`
  > div:last-child {
    margin-top: 25px;
  }

  padding-bottom: 10px;
  border-bottom: ${Colors.webGrey} 1px solid;

`;

const AccordionHeader = styled.div`
  display: flex;

  align-items: center;
  justify-content: space-between;

  cursor: pointer;

  h4, svg {
    margin-bottom: 22px;
  }
`;

const VolumeText = styled.p`
  font-family: ${ProximaNova};
  font-size: 14px;
  line-height: 100%;
  color: ${Colors.greyLight};
  margin: 0;
`;

const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: ${Colors.grey};
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin: 15px 0;

  ${LabelWrapper} {
    flex: 1;
    margin-left: 12px;

    ${props => props.oos && `

      ${Header5} {
        color: ${Colors.webGrey};
        text-decoration: line-through;
      }

      ${VolumeText} {
        color: ${Colors.webGrey};
      }
    `}
  }
`;

const OOSWrapper = styled(Body)`
flex: 1 1 100%;
display: block;
margin-left: 39px !important;

a {
  font-weight: bold;
  color: ${Colors.hunter};
}
`;

const Chevron = () => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 9l6 6 6-6"
      stroke={Colors.grey}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function CustomOption({ variant, selected, onToggle }) {
  return (
    <OptionWrapper oos={variant.product.slug === ""}>
      <Checkbox value={selected} onChange={onToggle} />
      <LabelWrapper>
        <Header5>{variant.name}</Header5>
        <VolumeText>{variant.volumeOrSize}</VolumeText>
      </LabelWrapper>
      {variant.product.slug === "" && <OOSWrapper>Out of stock. <Link to={`/products/${variant.product.slug}`}>Get notified</Link> when this item is back.</OOSWrapper>}
    </OptionWrapper>
  );
}

function calculateTotals(variants, selections) {
  const selected = Object.keys(selections).filter((v) => selections[v]);
  const filtered = variants.filter((v) => selected.includes(v.name));

  const individuals = filtered.reduce(
    (a, v) => a + parseFloat(v.individual?.price),
    0
  );
  
  const subscriptions = filtered.some(variant => !Boolean(variant.subscription)) ? null : filtered.reduce(
    (a, v) => a + parseFloat(v.subscription?.price),
    0
  );

  return [individuals, subscriptions];
}

export default function BundleCustomizer({
  onSetSelected,
  onSetCadence,
  onSetSelections,
  variants,
  options
}) {
  const [expanded, setExpanded] = useState(false);
  const [selections, setSelections] = useState(
    produce(variants, (draftVariants) => {
      return draftVariants.reduce((acc, v) => {
        // if (v.name !== "Invisible Daily SPF 30") {
          acc[v.name] = true;
        // }

        return acc;
      }, {});
    })
  );

  function onToggleVariant(vName) {
    // if (vName !== "Invisible Daily SPF 30") {
      const newSelections = produce(selections, (draft) => {
        draft[vName] = !draft[vName];
      });

      setSelections(newSelections);
      onSetSelections(newSelections);
    // }
  }

  const [individualTotal, subscriptionTotal] = calculateTotals(
    variants,
    selections
  );

  const BundleVariants = {
    subscription: subscriptionTotal ?  {
      price: subscriptionTotal,
    } : null,
    individual: {
      price: individualTotal,
    },
  };

  return (
    <Wrapper>
      <AccordionHeader onClick={() => setExpanded(!expanded)}>
        <Header4>Customize your routine</Header4>
        <Chevron />
      </AccordionHeader>
      {expanded && (
        <div>
          {variants?.map((variant) => (
            <CustomOption
              selected={selections[variant.name]}
              onToggle={() => onToggleVariant(variant.name)}
              variant={variant}
            />
          ))}
        </div>
      )}
      {SUBS_ENABLED && <ProductSubscriptionRadio
        onSelectDuration={onSetCadence}
        onSelectPurchaseType={onSetSelected}
        selectedVariant={BundleVariants}
        options={options}
      />}
    </Wrapper>
  );
}
